module.exports = __webpack_public_path__ + "img/onesignal.cf9ee757.png";